import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { adminGuard } from './core/guards/admin.guard';
import { AccessoCreateComponent } from './features/accessi/accesso-create/accesso-create.component';
import { SfgeTrendComponent } from './features/sfge/sfge-trend/sfge-trend.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/home/home.component')
        .then(m => m.HomeComponent)
  },
  {
    path: 'export',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/export/export-data/export-data.component')
        .then(m => m.ExportDataComponent)
  },
  {
    path: 'statistiche',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/statistiche/statistiche.component')
        .then(m => m.StatisticheComponent)
  },
  {
    path: 'research-datasets',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/research-datasets/research-dataset-jobs/research-dataset-jobs.component')
        .then(m => m.ResearchDatasetJobsComponent)
  },
  {
    path: 'auth/user-management',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./features/auth/user-management/user-management.component')
        .then(m => m.UserManagementComponent)
  },
  {
    path: 'auth/change-password',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/change-password/change-password.component')
        .then(m => m.ChangePasswordComponent)
  },
  {
    path: 'auth/two-factor/required',
    loadComponent: () =>
      import('./features/auth/two-factor/two-factor.component')
        .then(m => m.TwoFactorComponent)
  },
  {
    path: 'auth/two-factor',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/two-factor/two-factor.component')
        .then(m => m.TwoFactorComponent)
  },
  {
    path: 'backoffice/deleted-items',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./features/backoffice/deleted-items/deleted-items.component')
        .then(m => m.DeletedItemsComponent)
  },
  {
    path: 'backoffice/api-logs',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./features/backoffice/api-logs/api-logs.component')
        .then(m => m.ApiLogsComponent)
  },
  {
    path: 'backoffice/application-error-logs',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./features/backoffice/application-error-logs/application-error-logs.component')
        .then(m => m.ApplicationErrorLogsComponent)
  },
  {
    path: 'backoffice/manuale-utente',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/backoffice/user-manual/user-manual.component')
        .then(m => m.UserManualComponent)
  },
  {
    path: 'patients/advanced-search',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/patients/patient-advanced-search/patient-advanced-search.component')
        .then(m => m.PatientAdvancedSearchComponent)
  },
  {
    path: 'accessi/ricerca',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/accessi/accessi-search/accessi-search.component')
        .then(m => m.AccessiSearchComponent)
  },
  {
    path: 'valutazioni/storico',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/valutazioni/storico-valutazioni/storico-valutazioni.component')
        .then(m => m.StoricoValutazioniComponent)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'patients/:id',
    loadComponent: () =>
      import('./features/patients/patient-detail/patient-detail.component')
        .then(m => m.PatientDetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'accessi/nuovo',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/accessi/accesso-create/accesso-create.component')
        .then(m => m.AccessoCreateComponent)
  },
  {
    path: 'accessi/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/accessi/accesso-detail/accesso-detail.component')
        .then(m => m.AccessoDetailComponent)
  },
  {
    path: 'accessi/nuovo/:idPaziente',
    canActivate: [authGuard],
    component: AccessoCreateComponent
  },
  {
    path: 'sfge/:idAccesso',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/sfge/sfge-wizard/sfge-wizard.component')
        .then(m => m.SfgeWizardComponent)
  },
  {
    path: 'sunfrail/:idAccesso',
    loadComponent: () =>
      import('./features/sunfrail/sunfrail-wizard/sunfrail-wizard.component')
        .then(m => m.SunfrailWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'qualita-vita/:idAccesso',
    loadComponent: () =>
      import('./features/qualita-vita/qualita-vita-wizard/qualita-vita-wizard.component')
        .then(m => m.QualitaVitaWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'predimed/:idSunfrail',
    loadComponent: () =>
      import('./features/predimed/predimed-wizard/predimed-wizard.component')
        .then(m => m.PredimedWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sat/:idSunfrail',
    loadComponent: () =>
      import('./features/sat/sat-wizard/sat-wizard.component')
        .then(m => m.SatWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'afeat/:idSunfrail',
    loadComponent: () =>
      import('./features/afeat/afeat-wizard/afeat-wizard.component')
        .then(m => m.AfeatWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'mna/:idSunfrail',
    loadComponent: () =>
      import('./features/mna/mna-wizard/mna-wizard.component')
        .then(m => m.MnaWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'gds/:idSunfrail',
    loadComponent: () =>
      import('./features/gds/gds-wizard/gds-wizard.component')
        .then(m => m.GdsWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sppb/:idSunfrail',
    loadComponent: () =>
      import('./features/sppb/sppb-wizard/sppb-wizard.component')
        .then(m => m.SppbWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sps/:idSunfrail',
    loadComponent: () =>
      import('./features/sps/sps-wizard/sps-wizard.component')
        .then(m => m.SpsWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'qmci/:idSunfrail',
    loadComponent: () =>
      import('./features/qmci/qmci-wizard/qmci-wizard.component')
        .then(m => m.QmciWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'questionario-condizioni/:idSunfrail',
    loadComponent: () =>
      import('./features/questionario-condizioni/questionario-condizioni-wizard/questionario-condizioni-wizard.component')
        .then(m => m.QuestionarioCondizioniWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'mna/trend/:idPaziente',
    loadComponent: () =>
      import('./features/mna/mna-trend/mna-trend.component')
        .then(m => m.MnaTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sfge/trend/:idPaziente/:idAccesso',
    loadComponent: () =>
      import('./features/sfge/sfge-trend/sfge-trend.component')
        .then(m => m.SfgeTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'predimed/trend/:idPaziente',
    loadComponent: () =>
      import('./features/predimed/predimed-trend/predimed-trend.component')
        .then(m => m.PredimedTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sat/trend/:idPaziente',
    loadComponent: () =>
      import('./features/sat/sat-trend/sat-trend.component')
        .then(m => m.SatTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'afeat/trend/:idPaziente',
    loadComponent: () =>
      import('./features/afeat/afeat-trend/afeat-trend.component')
        .then(m => m.AfeatTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'gds/trend/:idPaziente',
    loadComponent: () =>
      import('./features/gds/gds-trend/gds-trend.component')
        .then(m => m.GdsTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sppb/trend/:idPaziente',
    loadComponent: () =>
      import('./features/sppb/sppb-trend/sppb-trend.component')
        .then(m => m.SppbTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sps/trend/:idPaziente',
    loadComponent: () =>
      import('./features/sps/sps-trend/sps-trend.component')
        .then(m => m.SpsTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'qmci/trend/:idPaziente',
    loadComponent: () =>
      import('./features/qmci/qmci-trend/qmci-trend.component')
        .then(m => m.QmciTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'questionario-condizioni/trend/:idPaziente',
    loadComponent: () =>
      import('./features/questionario-condizioni/questionario-condizioni-trend/questionario-condizioni-trend.component')
        .then(m => m.QuestionarioCondizioniTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'checklist-visite-mediche/trend/:idPaziente',
    loadComponent: () =>
      import('./features/checklist-visite-mediche/checklist-visite-mediche-trend/checklist-visite-mediche-trend.component')
        .then(m => m.ChecklistVisiteMedicheTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'checklist-visite-mediche/:idSunfrail',
    loadComponent: () =>
      import('./features/checklist-visite-mediche/checklist-visite-mediche-wizard/checklist-visite-mediche-wizard.component')
        .then(m => m.ChecklistVisiteMedicheWizardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sfge-trend/:idPaziente',
    canActivate: [authGuard],
    component: SfgeTrendComponent
  },
  {
    path: 'sunfrail-trend/:idPaziente',
    loadComponent: () =>
      import('./features/sunfrail/sunfrail-trend/sunfrail-trend.component')
        .then(m => m.SunfrailTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'qualita-vita-trend/:idPaziente',
    loadComponent: () =>
      import('./features/qualita-vita/qualita-vita-trend/qualita-vita-trend.component')
        .then(m => m.QualitaVitaTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sunfrail-trend/:idPaziente/:idAccesso',
    loadComponent: () =>
      import('./features/sunfrail/sunfrail-trend/sunfrail-trend.component')
        .then(m => m.SunfrailTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'qualita-vita-trend/:idPaziente/:idAccesso',
    loadComponent: () =>
      import('./features/qualita-vita/qualita-vita-trend/qualita-vita-trend.component')
        .then(m => m.QualitaVitaTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'rischio-cadute-trend/:idPaziente',
    loadComponent: () =>
      import('./features/rischio-cadute/rischio-cadute-trend/rischio-cadute-trend.component')
        .then(m => m.RischioCaduteTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'rischio-cadute-trend/:idPaziente/:idAccesso',
    loadComponent: () =>
      import('./features/rischio-cadute/rischio-cadute-trend/rischio-cadute-trend.component')
        .then(m => m.RischioCaduteTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'valutazione-nutrizionale-trend/:idPaziente',
    loadComponent: () =>
      import('./features/valutazione-nutrizionale/valutazione-nutrizionale-trend/valutazione-nutrizionale-trend.component')
        .then(m => m.ValutazioneNutrizionaleTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'valutazione-nutrizionale-trend/:idPaziente/:idAccesso',
    loadComponent: () =>
      import('./features/valutazione-nutrizionale/valutazione-nutrizionale-trend/valutazione-nutrizionale-trend.component')
        .then(m => m.ValutazioneNutrizionaleTrendComponent),
    canActivate: [authGuard]
  },
  {
    path: 'rilevazione-trend/:idPaziente',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './features/rilevazioni/rilevazione-trend/rilevazione-trend.component'
      ).then(
        m => m.RilevazioneTrendComponent
      )
  },
  {
    path: 'rilevazione-trend/:idPaziente/:idAccesso',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './features/rilevazioni/rilevazione-trend/rilevazione-trend.component'
      ).then(
        m => m.RilevazioneTrendComponent
      )
  },
  {
    path: 'patient-general-trend/:idPatient',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/patients/patient-general-trend/patient-general-trend.component')
        .then(m => m.PatientGeneralTrendComponent)
  }
];
